import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../utils/cookies";

const AuthRoute = ({ children, type = "protected", redirectTo = "/login" }) => {
  const cookieToken = getToken();

  const isAuthenticatedUser = cookieToken;

  if (type === "protected") {
    return isAuthenticatedUser ? (
      children
    ) : (
      <Navigate to={redirectTo} replace />
    );
  } else {
    return isAuthenticatedUser ? <Navigate to="/" replace /> : children;
  }
};

export default AuthRoute;
